import { AlertCircle, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { SupportRequestError } from "@/lib/orderSupportRequestError";

/**
 * Desfecho do envio que não pertence a um campo: 409 (já existe solicitação aberta, com o ticket), regra,
 * pedido não encontrado, 503 e rede. Erros de validação aparecem nos próprios campos.
 */
export const SupportRequestErrorAlert = ({ error }: { error: SupportRequestError }) => {
  if (error.kind === "validation") return null;

  if (error.kind === "alreadyOpen") {
    return (
      <Alert className="border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-100 [&>svg]:text-amber-600">
        <AlertTriangle className="h-4 w-4" aria-hidden="true" />
        <AlertTitle className="font-semibold">Já existe uma solicitação aberta</AlertTitle>
        <AlertDescription className="flex flex-col gap-1">
          <p>{error.message}</p>
          <p>
            {error.zendeskTicketId ? (
              <>
                Ticket <strong className="font-semibold">#{error.zendeskTicketId}</strong>.{" "}
              </>
            ) : null}
            Acompanhe o andamento em "Acompanhar minhas solicitações".
          </p>
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" aria-hidden="true" />
      <AlertDescription>{error.message}</AlertDescription>
    </Alert>
  );
};
